




























import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  props: {
    recibos: {},
    disabled: Boolean,
  },
  data: () => ({
    menu: false,
    date: new Date().toISOString().substr(0, 10),
    finishDialog: false,
    headers: [
      { text: 'Cantidad', value: 'cantidad' },
      { text: 'Concepto', value: 'concepto.nombre' },
      { text: 'Descripción', value: 'descripcion' },
      { text: 'Precio unitario', value: 'unitario' },
      { text: 'Importe', value: 'importe' },
    ],
    items: [
    ],
    nuevoItem: {
      cantidad: '',
      concepto: {},
      descripcion: '',
      unidadDeMedida: '',
      unitario: '',
      importe: 0,
    },
    Recibo: '',
    loading: false,
    result: {},
    var: 0,
    unidades: [],
    conceptos: [],
    unidadSeleccionada: {},
    conceptoSeleccionado: {},
    propietarioSeleccionado: {},
    asociar: false,
    propietarios: [],
    total: 0,
    selected: [],
    isSelectedEmpty: true,
    wasSent: false,
  }),
  methods: {
    async generar() {
      console.log('GENERANDO RECORDATORIOS');
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const recibo = this.recibos;
        this.loading = true;
        const result = await this.$store.dispatch('generarAviso', { admin, condo, recibo});
        this.Recibo = result;
      } catch (e) {
        // this.$toast.error(e);
        this.$toast.error(e.response.data.message);
        this.wasSent = true;
      }
      this.loading = false;
    },
    async sendData() {
      this.wasSent = true;
      try {
        console.log('Recibo Solo');
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const recibos = this.recibos;
        // console.log('this.recibo: %o', this.recibo);
        this.loading = true;
        const result = await this.$store.dispatch('multiRecibos', {admin, condo, recibos});
        this.$toast.success('Recibo Enviado');
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
    },
    printData() {
      this.$htmlToPaper('reciboImprimir');
    },
  },
  watch: {
    selected() {
      console.log('watch selected: %o', this.selected);
    },
    finishDialog() {
      if (this.finishDialog) {
        this.generar();
        this.wasSent = false;
        this.Recibo = '';
      }
    },
  },
});
